import React from "react";
import { cn } from "utils";
import { PriceChangePercentage } from "./Chat/Cards/type";
import { formatBigNumber } from "@utils/formatBigNumber";
import { numberStatus } from "@utils/numberStatus";

/**
 * 价格涨跌表组件
 * 展示加密货币在不同时间段的价格变化百分比
 */
const PriceChangeItem: React.FC<{
  item: PriceChangePercentage;
  index: number;
}> = ({ item }) => {
  // 使用工具函数分析数值状态
  const {
    isPositive,
    isNegative,
    isZero: isZeroValue,
    isNull,
    absValue,
  } = numberStatus(item.percentage);

  const percentage = formatBigNumber(absValue, {
    needFormat: true,
    precision: 2,
    trimZeros: true,
  });

  const isZero = isZeroValue || Number(percentage) === 0;

  const renderCell = () => {
    // 为空值提供特殊处理
    if (isNull) {
      return (
        <div className="body_s text-center text-content_tertiary font-bold">
          --
        </div>
      );
    }

    return (
      <div
        className={cn("body_medium_s md:body_medium_m text-center", {
          "text-content_secondary": isZero,
          "text-content_accent1_primary": !isZero && isPositive,
          "text-content_accent2_primary": !isZero && isNegative,
        })}
      >
        <div className="flex items-center justify-center flex-1">
          {!isZero && (isPositive ? "+" : "-")}
          {percentage}%
        </div>
      </div>
    );
  };

  // 根据涨跌情况设置不同的背景色
  const bgClass = isZero
    ? "bg-background_white_overlay5"
    : isPositive
      ? "bg-background_accent1_overlay10" // 涨-淡绿色背景
      : isNegative
        ? "bg-background_accent2_overlay10" // 跌-淡红色背景
        : "bg-background_white_overlay5"; // 零或空值-无背景

  return (
    <div
      className={cn(
        "flex flex-col items-center gap-0.5 px-0 py-1 w-full justify-center h-11",
        bgClass,
      )}
    >
      {/* 时间标签 */}
      <div
        className={cn("body_medium_s md:body_s font-normal relative w-fit", {
          "text-content_tertiary": isZero,
          "text-content_accent1_primary": !isZero && isPositive,
          "text-content_accent2_primary": !isZero && isNegative,
        })}
      >
        {item.time_period}
      </div>

      {/* 百分比数值 */}
      {renderCell()}
    </div>
  );
};

export default PriceChangeItem;
